import React from "react";
import { modelPricesDelete } from "../../../../api/api";
import { useModelPrices } from "../../../../state/api/ai/useModelPrices";
import { useModels } from "../../../../state/api/ai/useModels";
import { Doc, ModelPrice } from "../../../../types";
import DeleteButton from "../../buttons/DeleteButton";
import PageLoader from "../../loader/PageLoader";
import Pill from "../../pill/Pill";
import EditPriceButton from "./EditPriceButton";

interface Props {
  price: Doc<ModelPrice>;
  usedBy: number;
}

function PriceCard(props: Props) {

  const {
    price,
    usedBy
  } = props;

  const { reloadModelPrices } = useModelPrices();

  return (
    <div className="border rounded p-3 d-flex flex-column gap-2">
      <div className="d-flex flex-row gap-4 align-items-center justify-content-between">
        <div className="d-flex flex-column">
          <h6>{price.label || "Unnamed tier"}</h6>
          <div className="d-flex flex-row gap-1">
            {
              usedBy === 0
                ? <Pill>Unused</Pill>
                : <Pill>{usedBy} model{usedBy === 1 ? "" : "s"}</Pill>
            }
          </div>
        </div>
        <div className="d-flex flex-row gap-1">
          <EditPriceButton price={price} />
          <DeleteButton
            apiCall={() => modelPricesDelete(price._id)}
            afterDelete={reloadModelPrices}
          />
        </div>
      </div>
      <div style={{ height: "1px", width: "100%", backgroundColor: "var(--gray-100)" }} />
      <div className="d-flex flex-column gap-1">
        <span className="font-code font-s">Base input: ${price.ppmInputTokens} / MTok</span>
        <span className="font-code font-s">5m cache writes: ${price.ppmInputTokensCacheWrite5m} / MTok</span>
        <span className="font-code font-s">1h cache writes: ${price.ppmInputTokensCacheWrite1h} / MTok</span>
        <span className="font-code font-s">Cache hits & refreshes: ${price.ppmInputTokensCacheRead} / MTok</span>
        <span className="font-code font-s">Output: ${price.ppmOutputTokens} / MTok</span>
      </div>
    </div>
  )
}

export default function PriceManagement() {

  const { modelPrices, loadingModelPrices } = useModelPrices();
  const { models, loadingModels } = useModels();

  if (loadingModelPrices || loadingModels) return <PageLoader />;

  return (
    <div className="d-flex flex-column gap-3 ps-4 pe-4 ps-sm-3 pe-sm-3 pt-4" style={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
      {
        modelPrices.length
          ? (
            modelPrices.map(x => (
              <PriceCard
                key={x._id}
                price={x}
                usedBy={models.filter(m => m.price === x._id).length}
              />
            ))
          )
          : <span>No prices</span>
      }
    </div>
  )
}
